function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledBaseHeaderComponent } from "./base-header-component.scss";
import BaseHeaderDesktopComponent from "./base-header-desktop/base-header-desktop-component";
import BaseHeaderMobileComponent from "./base-header-mobile/base-header-mobile-component";
import { MOBILE_OR_TABLE_VIEW } from "/constants/bigbrain-event-types";
import DefaultProps from "./default-props";
import { withGenericConfig } from "/contexts/generic-config-context";
class BaseHeaderComponent extends PureComponent {
    componentDidMount() {
        this.trackIsMobileOrTablet();
    }
    trackIsMobileOrTablet() {
        const mobileWrapper = document.querySelector(".mobile-wrapper");
        if (mobileWrapper) {
            const isMobileWrapperRendered = mobileWrapper.offsetParent !== null;
            if (isMobileWrapperRendered) BigBrain("track", MOBILE_OR_TABLE_VIEW, {
                kind: location.pathname
            });
        }
    }
    render() {
        return /*#__PURE__*/ _jsxs(StyledBaseHeaderComponent, {
            className: "base-header-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "desktop-wrapper",
                    children: /*#__PURE__*/ _jsx(BaseHeaderDesktopComponent, _object_spread({
                        isSecondaryMenuNeeded: this.isSecondaryMenuNeeded
                    }, this.props))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-wrapper",
                    children: /*#__PURE__*/ _jsx(BaseHeaderMobileComponent, _object_spread({
                        isSecondaryMenuNeeded: this.isSecondaryMenuNeeded
                    }, this.props))
                })
            ]
        });
    }
    constructor(props){
        super(props);
        const { isSecondaryMenuNeeded } = props;
        this.isSecondaryMenuNeeded = isSecondaryMenuNeeded;
    }
}
BaseHeaderComponent.defaultProps = DefaultProps;
export default withGenericConfig(BaseHeaderComponent);
